import fr from 'apexcharts/dist/locales/fr.json';
import en from 'apexcharts/dist/locales/en.json';
import es from 'apexcharts/dist/locales/es.json';
import uk from 'apexcharts/dist/locales/uk.json';
import pl from 'apexcharts/dist/locales/pl.json';
// ApexCharts ships its own `ro.json`, but it abbreviates November as "Nov";
// the local copy keeps the correct Romanian "Noi".
import ro from '@lib/locales/ro/apexcharts.json';

export function getApexchartsLocales(locale = 'fr') {
  return {
    locales: [en, fr, es, uk, pl, ro],
    defaultLocale: locale,
  };
}
